import { useQuery } from '@tanstack/react-query';
import { contractsControllerListV1 } from '@/api/generated/contracts/contracts';
import {
  ContractsControllerListV1SortBy,
  ContractsControllerListV1SortOrder,
  type ContractsControllerListV1Params,
} from '@/api/generated/model';
import { contractKeys } from '@/shared/lib/contractKeys';

/**
 * Every contract naming one player, newest end date first.
 *
 * Shared by the player's Contract tab and offboarding's termination step. Fifty
 * is the cap on one page and far beyond what one player accrues; the register
 * is where an agency scrolls through everything.
 */
export function usePlayerContractsQuery(playerId: string | undefined) {
  const params: ContractsControllerListV1Params = {
    playerId: playerId ?? '',
    limit: 50,
    sortBy: ContractsControllerListV1SortBy.endDate,
    sortOrder: ContractsControllerListV1SortOrder.desc,
  };
  return useQuery({
    queryKey: contractKeys.list(params),
    queryFn: ({ signal }) => contractsControllerListV1(params, { signal }),
    enabled: Boolean(playerId),
  });
}
